import { Flex, TextInput, ToogleSwitch } from "/app/src/component";
import React from "react";
const OfflineFormularsContainerStyle = {
  dataName: "OfflineFormularsContainer",
  hAlignContent: "center",
  column: true,
  width: "100%",
  mb: "20px",
  mt: "50px",
  shrink: 0,
  color: "black",
};
const FormularsContainerHeaderStyle = {
  dataName: "FormularsContainerHeader",
  column: true,
  color: "black",
  fontSize: "24px",
  fontWeight: "300",
  w: "70%",
  hAlignContent: "center",
  marginBottom: "15px",
};

const FormularContainerLabelStyle = {
  color: "black",
  fontSize: "24px",
  fontWeight: "300",
  my: "5px",
  hA: "left",
  w: "100%",
};
const Description = {
  color: "black",
  fontSize: "18px",
  my: "5px",
  w: "100%",
  hA: "left",
};
const SmallContainerStyle = {
  maxWidth: "456px",
  width: "100%",
  grow: 1,
};

export default ({
  offlineEmail,
  setOfflineEmail,
  offlineEmailOn,
  setOfflineEmailOn,
}) => {
  return (
    <Flex {...OfflineFormularsContainerStyle}>
      <Flex {...FormularsContainerHeaderStyle}>
        <Flex {...FormularContainerLabelStyle} {...SmallContainerStyle}>
          Offlineformulär - email
          <ToogleSwitch
            marginLeft="8px"
            on={offlineEmailOn}
            onChange={(event) => {
              setOfflineEmailOn(event.target.value);
            }}
          />
        </Flex>
        <Flex {...Description} {...SmallContainerStyle}>
          När offline-formuläret är aktivt så får du även meddelandet skickat
          till email-adressen nedanför:
        </Flex>
        <Flex
          {...SmallContainerStyle}
          height="60px"
          fontSize="18px"
          paddingTop="8px"
        >
          <TextInput
            disabled={!offlineEmailOn}
            value={offlineEmail}
            onChange={(event) => {
              setOfflineEmail(event.target.value);
            }}
            autoComplete="email"
            label="email@example.com"
          />
        </Flex>
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/_OfflineEmail.js